import { render, staticRenderFns } from "./ShangquanFenbu.vue?vue&type=template&id=736f7d0c&scoped=true&"
import script from "./ShangquanFenbu.vue?vue&type=script&lang=js&"
export * from "./ShangquanFenbu.vue?vue&type=script&lang=js&"
import style0 from "./ShangquanFenbu.vue?vue&type=style&index=0&id=736f7d0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736f7d0c",
  null
  
)

export default component.exports